import { apiGet } from "./api";
import type { Phase2State } from "./types";
import { getStoredJobId } from "./utils";

export const DRAFT_STORAGE_KEY = "orion1.phase1.draft";

export function readDeskTargetFromStorage(): string {
  try {
    const raw = sessionStorage.getItem(DRAFT_STORAGE_KEY);
    if (!raw) return "";
    const parsed = JSON.parse(raw) as { target_company?: string };
    return String(parsed.target_company || "").trim();
  } catch {
    return "";
  }
}

export function jobIdFromPhase2State(state: Phase2State): string {
  return (
    state.canonical_job_id ||
    state.job_id ||
    state.job?.job_id ||
    ""
  ).trim();
}

export async function resolveJobForDeskTarget(
  target: string,
): Promise<{ jobId: string; target: string; state: Phase2State } | null> {
  const trimmed = target.trim();
  if (!trimmed) return null;
  try {
    const data = await apiGet<{ state: Phase2State }>(
      `/api/phase2/state?target=${encodeURIComponent(trimmed)}`,
    );
    const jobId = jobIdFromPhase2State(data.state);
    if (!jobId) return null;
    return {
      jobId,
      target: String(data.state.target_company || trimmed).trim(),
      state: data.state,
    };
  } catch {
    return null;
  }
}

/** Sidebar / deep links: prefer stored job, else desk target query param. */
export function deskScopedHref(path: string): string {
  const jid = getStoredJobId();
  if (jid) return `${path}?job_id=${encodeURIComponent(jid)}`;
  const target = readDeskTargetFromStorage();
  if (target) return `${path}?target=${encodeURIComponent(target)}`;
  return path;
}
